// Belt-and-suspenders alongside the CSS `pointer-events: none` rule on
// `.pdp-immersive-gallery .product__modal-opener`: intercept in the CAPTURE
// phase at the document level (fires before Dawn's own listeners, which are
// wherever they are in the tree) so tapping the full-screen photo never opens
// Dawn's built-in zoom modal. Real devices showed the CSS-only rule wasn't
// enough to stop it, so this stops the click before it can reach Dawn's
// handler at all. Only 'click' is intercepted (not touchstart/touchmove), so
// native horizontal swipe-scrolling between photos is untouched.
document.addEventListener(
  'click',
  function (e) {
    var opener = e.target.closest && e.target.closest('.pdp-immersive-gallery .product__modal-opener');
    if (opener) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) {
        e.stopImmediatePropagation();
      }
    }
  },
  true
);

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pdp-immersive-back]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = '/';
      }
    });
  });

  document.querySelectorAll('[data-pdp-immersive-share]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var title = btn.getAttribute('data-share-title') || document.title;
      var url = btn.getAttribute('data-share-url') || window.location.href;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () {
          btn.setAttribute('data-copied', 'true');
          setTimeout(function () {
            btn.removeAttribute('data-copied');
          }, 1500);
        });
      }
    });
  });

  // As the customer swipes through the full-screen gallery, show a small
  // floating label with the color name of whichever photo is currently in
  // view (when that photo belongs to a specific color variant), AND
  // highlight the matching real color swatch button so it visually looks
  // "selected" for that color. Both are DELIBERATELY read-only: this code
  // only ever reads which slide is visible and (a) writes text into the
  // badge, (b) toggles a CSS class on the matching swatch <label>. It never
  // checks a swatch radio button's `checked` property and never fires a
  // variant 'change' event. That's intentional — Dawn's own variant-change
  // handling (assets/product-info.js) does a network fetch and then
  // re-sorts the gallery's <li> elements (prepending the newly selected
  // variant's photo to the front of the list) and force-scrolls the
  // gallery to it. Wiring that up to fire on every swipe would fight the
  // customer's own swipe, reorder photos out from under their thumb, and
  // spam network requests. So swiping only ever updates the badge text and
  // the swatch's visual highlight; actually switching color/variant (price,
  // SKU, add-to-cart target) is still a deliberate tap on the real swatch.
  document.querySelectorAll('.pdp-immersive-gallery').forEach(function (gallery) {
    var mapScript = gallery.querySelector('[data-pdp-immersive-color-map]');
    var badge = gallery.querySelector('[data-pdp-immersive-color-badge]');
    var list = gallery.querySelector('.product__media-list');
    if (!mapScript || !badge || !list) return;

    var colorByMediaId = {};
    try {
      JSON.parse(mapScript.textContent).forEach(function (entry) {
        colorByMediaId[String(entry.mediaId)] = entry.color;
      });
    } catch (err) {
      return;
    }

    var slides = Array.from(list.querySelectorAll('[data-pdp-media-numeric-id]'));
    if (!slides.length) return;

    // The real color swatches live in the variant picker (product-info),
    // entirely outside .pdp-immersive-gallery, rendered by
    // snippets/product-variant-options.liquid as
    // `<label class="pill-color-swatch" title="{{ value.name }}">`. The
    // `title` is the exact raw option value (e.g. "BROWN1764"), the same
    // raw string captured as `color` in the media-id -> color map above
    // (both come from `value`/`pdp_variant.options[...]`), so matching by
    // exact title text reliably finds the right swatch without needing a
    // shared id. Gathered once — the swatch list doesn't change as the
    // customer swipes, only as Dawn's own AJAX variant swap replaces
    // product-info (see swatchLabels() re-query below for that case).
    function swatchLabels() {
      return Array.from(document.querySelectorAll('label.pill-color-swatch'));
    }

    var highlightedLabel = null;

    function highlightSwatch(color) {
      if (highlightedLabel) {
        highlightedLabel.classList.remove('pdp-immersive-swipe-active');
        highlightedLabel = null;
      }
      if (!color) return;
      var match = swatchLabels().find(function (label) {
        return label.title === color;
      });
      if (match) {
        match.classList.add('pdp-immersive-swipe-active');
        highlightedLabel = match;
      }
    }

    var currentColor = null;

    function showColor(color) {
      if (color === currentColor) return;
      currentColor = color;
      if (color) {
        badge.textContent = color;
        badge.hidden = false;
      } else {
        badge.hidden = true;
      }
      highlightSwatch(color);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var best = null;
        entries.forEach(function (entry) {
          if (!best || entry.intersectionRatio > best.intersectionRatio) {
            best = entry;
          }
        });
        if (best && best.intersectionRatio > 0.6) {
          var mediaId = best.target.getAttribute('data-pdp-media-numeric-id');
          showColor(colorByMediaId[mediaId] || null);
        }
      },
      { root: list, threshold: [0, 0.6, 1] }
    );

    slides.forEach(function (slide) {
      observer.observe(slide);
    });
  });

  // Dawn's own SliderComponent (assets/global.js) recomputes and overwrites
  // the "total" number in the "1 / N" counter on every scroll:
  //   slidesPerPage = Math.floor((slider.clientWidth - firstItem.offsetLeft) / itemOffset)
  //   totalPages = sliderItemsToShow.length - slidesPerPage + 1
  // That formula is built for a "peek" carousel that can show MULTIPLE
  // items per page, and only stays correct when slidesPerPage resolves to
  // 1. Our full-bleed immersive redesign always shows exactly one
  // full-width photo at a time, so slidesPerPage should always be 1 — but
  // sub-pixel layout rounding (fractional viewport widths, browser-specific
  // offsetLeft rounding) can occasionally round that division down to 0,
  // which inflates totalPages by one (e.g. showing "3 / 4" for a product
  // that only has 3 real photos, and the swipe understandably appearing to
  // "stop early" at the true last photo). Rather than patch Dawn's shared
  // global.js (used by every other slider on the site) or race against its
  // own script/upgrade timing, keep the total pinned to the real,
  // server-rendered count.
  //
  // IMPORTANT: the "correct" value must come from a static
  // data-correct-total="{{ render_media_count }}" attribute rendered by
  // Liquid (snippets/product-media-gallery.liquid), NOT from this element's
  // live textContent. slider-component is a custom element, and custom
  // element constructors run as soon as the browser's HTML parser reaches
  // the tag — which can happen well before DOMContentLoaded fires. That
  // means Dawn's SliderComponent can already have overwritten the counter
  // text by the time this DOMContentLoaded handler runs, so capturing
  // "whatever text is there right now" is unreliable — it can just as
  // easily lock in the WRONG number as the right one. The data attribute is
  // never touched by Dawn's script, so it's a safe source of truth
  // regardless of timing. Every occurrence is resynced immediately (in case
  // it was already corrupted before this ran) and then kept in sync via
  // MutationObserver for every later overwrite (scroll, resize, etc.). The
  // "current" page number is left untouched — that part of Dawn's math
  // (scrollLeft / itemOffset) is unaffected by this bug.
  document.querySelectorAll('.pdp-immersive-gallery .slider-counter--total').forEach(function (totalEl) {
    var correctTotal = totalEl.getAttribute('data-correct-total') || totalEl.textContent;
    var resync = function () {
      if (totalEl.textContent !== correctTotal) {
        totalEl.textContent = correctTotal;
      }
    };
    resync();
    new MutationObserver(resync).observe(totalEl, { childList: true, characterData: true, subtree: true });
  });
});
